import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import HorseProfileTable from './HorseProfileTable';

export default class HorseProfileResultsPage extends Component {
  static propTypes = {
    profile: PropTypes.object
  };

  render() {
    const {
      profile = {},
      profile: {
        name
      } = {}
    } = this.props;

    return (
      <div className="horse-profile-results">
        <MetaDataWrapper title={`${name} - Horse Profile`}/>
        <HorseProfileTable profile={profile} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/HorseProfileResultsPage.js